/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/accounting/service.proto" (package "rd.api.accounting", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AccountingService } from "./service_pb";
import type { DownloadJournalEntryCSVRes } from "./service_pb";
import type { DownloadJournalEntryCSVReq } from "./service_pb";
import type { ArchiveJournalEntryRes } from "./service_pb";
import type { ArchiveJournalEntryReq } from "./service_pb";
import type { GetJournalEntrySage100CSVRes } from "./service_pb";
import type { GetJournalEntrySage100CSVReq } from "./service_pb";
import type { GetJournalEntryQuickbooksDesktopIIFRes } from "./service_pb";
import type { GetJournalEntryQuickbooksDesktopIIFReq } from "./service_pb";
import type { ExportJournalEntryToQuickbooksOnlineRes } from "./service_pb";
import type { ExportJournalEntryToQuickbooksOnlineReq } from "./service_pb";
import type { GenerateJournalEntryForOrderShipmentRes } from "./service_pb";
import type { GenerateJournalEntryForOrderShipmentReq } from "./service_pb";
import type { GenerateJournalEntriesV2Res } from "./service_pb";
import type { GenerateJournalEntriesV2Req } from "./service_pb";
import type { GetJournalEntryRes } from "./service_pb";
import type { GetJournalEntryReq } from "./service_pb";
import type { GenerateGeneralLedgerCSVRes } from "./service_pb";
import type { GenerateGeneralLedgerCSVReq } from "./service_pb";
import type { GenerateGeneralLedgerPDFRes } from "./service_pb";
import type { GenerateGeneralLedgerPDFReq } from "./service_pb";
import type { GenerateGeneralLedgerRes } from "./service_pb";
import type { GenerateGeneralLedgerReq } from "./service_pb";
import type { GeneratePayoutReconciliationRes } from "./service_pb";
import type { GeneratePayoutReconciliationReq } from "./service_pb";
import type { GetExternalTransactionRes } from "./service_pb";
import type { GetExternalTransactionReq } from "./service_pb";
import type { VoidExternalTransactionRes } from "./service_pb";
import type { VoidExternalTransactionReq } from "./service_pb";
import type { UpdateExternalTransactionRes } from "./service_pb";
import type { UpdateExternalTransactionReq } from "./service_pb";
import type { CreateExternalTransactionRes } from "./service_pb";
import type { CreateExternalTransactionReq } from "./service_pb";
import type { GetExternalAccountBalanceRes } from "./service_pb";
import type { GetExternalAccountBalanceReq } from "./service_pb";
import type { ListExternalAccountsRes } from "./service_pb";
import type { ListExternalAccountsReq } from "./service_pb";
import type { DeactivateExternalAccountRes } from "./service_pb";
import type { DeactivateExternalAccountReq } from "./service_pb";
import type { UpdateExternalAccountRes } from "./service_pb";
import type { UpdateExternalAccountReq } from "./service_pb";
import type { CreateExternalAccountRes } from "./service_pb";
import type { CreateExternalAccountReq } from "./service_pb";
import type { GenerateJournalEntriesIIFRes } from "./service_pb";
import type { GenerateJournalEntriesIIFReq } from "./service_pb";
import type { GenerateJournalEntriesPDFRes } from "./service_pb";
import type { GenerateJournalEntriesPDFReq } from "./service_pb";
import type { GenerateJournalEntriesRes } from "./service_pb";
import type { GenerateJournalEntriesReq } from "./service_pb";
import type { GenerateIncomeStatementRes } from "./service_pb";
import type { GenerateIncomeStatementReq } from "./service_pb";
import type { GenerateBalanceSheetRes } from "./service_pb";
import type { GenerateBalanceSheetReq } from "./service_pb";
import type { BulkUpsertMappingsRes } from "./service_pb";
import type { BulkUpsertMappingsReq } from "./service_pb";
import type { UpdateMappingAccountRes } from "./service_pb";
import type { UpdateMappingAccountReq } from "./service_pb";
import type { ListMappingsRes } from "./service_pb";
import type { ListMappingsReq } from "./service_pb";
import type { BulkUpsertAccountsRes } from "./service_pb";
import type { BulkUpsertAccountsReq } from "./service_pb";
import type { ReactivateAccountRes } from "./service_pb";
import type { ReactivateAccountReq } from "./service_pb";
import type { DeactivateAccountRes } from "./service_pb";
import type { DeactivateAccountReq } from "./service_pb";
import type { UpdateAccountRes } from "./service_pb";
import type { UpdateAccountReq } from "./service_pb";
import type { ListAccountsRes } from "./service_pb";
import type { ListAccountsReq } from "./service_pb";
import type { GetAccountRes } from "./service_pb";
import type { GetAccountReq } from "./service_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreateAccountRes } from "./service_pb";
import type { CreateAccountReq } from "./service_pb";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service rd.api.accounting.AccountingService
 */
export interface IAccountingServiceClient {
    /**
     * Account
     *
     * @generated from protobuf rpc: CreateAccount
     */
    createAccount(input: CreateAccountReq, options?: RpcOptions): UnaryCall<CreateAccountReq, CreateAccountRes>;
    /**
     * @generated from protobuf rpc: GetAccount
     */
    getAccount(input: GetAccountReq, options?: RpcOptions): UnaryCall<GetAccountReq, GetAccountRes>;
    /**
     * @generated from protobuf rpc: ListAccounts
     */
    listAccounts(input: ListAccountsReq, options?: RpcOptions): UnaryCall<ListAccountsReq, ListAccountsRes>;
    /**
     * @generated from protobuf rpc: UpdateAccount
     */
    updateAccount(input: UpdateAccountReq, options?: RpcOptions): UnaryCall<UpdateAccountReq, UpdateAccountRes>;
    /**
     * @generated from protobuf rpc: DeactivateAccount
     */
    deactivateAccount(input: DeactivateAccountReq, options?: RpcOptions): UnaryCall<DeactivateAccountReq, DeactivateAccountRes>;
    /**
     * @generated from protobuf rpc: ReactivateAccount
     */
    reactivateAccount(input: ReactivateAccountReq, options?: RpcOptions): UnaryCall<ReactivateAccountReq, ReactivateAccountRes>;
    /**
     * @generated from protobuf rpc: BulkUpsertAccounts
     */
    bulkUpsertAccounts(input: BulkUpsertAccountsReq, options?: RpcOptions): UnaryCall<BulkUpsertAccountsReq, BulkUpsertAccountsRes>;
    /**
     * Mapping
     *
     * @generated from protobuf rpc: ListMappings
     */
    listMappings(input: ListMappingsReq, options?: RpcOptions): UnaryCall<ListMappingsReq, ListMappingsRes>;
    /**
     * @generated from protobuf rpc: UpdateMappingAccount
     */
    updateMappingAccount(input: UpdateMappingAccountReq, options?: RpcOptions): UnaryCall<UpdateMappingAccountReq, UpdateMappingAccountRes>;
    /**
     * @generated from protobuf rpc: BulkUpsertMappings
     */
    bulkUpsertMappings(input: BulkUpsertMappingsReq, options?: RpcOptions): UnaryCall<BulkUpsertMappingsReq, BulkUpsertMappingsRes>;
    /**
     * Balance Sheet
     *
     * @generated from protobuf rpc: GenerateBalanceSheet
     */
    generateBalanceSheet(input: GenerateBalanceSheetReq, options?: RpcOptions): UnaryCall<GenerateBalanceSheetReq, GenerateBalanceSheetRes>;
    /**
     * Income Statement
     *
     * @generated from protobuf rpc: GenerateIncomeStatement
     */
    generateIncomeStatement(input: GenerateIncomeStatementReq, options?: RpcOptions): UnaryCall<GenerateIncomeStatementReq, GenerateIncomeStatementRes>;
    /**
     * JournalEntries
     *
     * @generated from protobuf rpc: GenerateJournalEntries
     */
    generateJournalEntries(input: GenerateJournalEntriesReq, options?: RpcOptions): UnaryCall<GenerateJournalEntriesReq, GenerateJournalEntriesRes>;
    /**
     * @generated from protobuf rpc: GenerateJournalEntriesPDF
     */
    generateJournalEntriesPDF(input: GenerateJournalEntriesPDFReq, options?: RpcOptions): UnaryCall<GenerateJournalEntriesPDFReq, GenerateJournalEntriesPDFRes>;
    /**
     * @generated from protobuf rpc: GenerateJournalEntriesIIF
     */
    generateJournalEntriesIIF(input: GenerateJournalEntriesIIFReq, options?: RpcOptions): UnaryCall<GenerateJournalEntriesIIFReq, GenerateJournalEntriesIIFRes>;
    /**
     * External Accounts
     *
     * @generated from protobuf rpc: CreateExternalAccount
     */
    createExternalAccount(input: CreateExternalAccountReq, options?: RpcOptions): UnaryCall<CreateExternalAccountReq, CreateExternalAccountRes>;
    /**
     * @generated from protobuf rpc: UpdateExternalAccount
     */
    updateExternalAccount(input: UpdateExternalAccountReq, options?: RpcOptions): UnaryCall<UpdateExternalAccountReq, UpdateExternalAccountRes>;
    /**
     * @generated from protobuf rpc: DeactivateExternalAccount
     */
    deactivateExternalAccount(input: DeactivateExternalAccountReq, options?: RpcOptions): UnaryCall<DeactivateExternalAccountReq, DeactivateExternalAccountRes>;
    /**
     * @generated from protobuf rpc: ListExternalAccounts
     */
    listExternalAccounts(input: ListExternalAccountsReq, options?: RpcOptions): UnaryCall<ListExternalAccountsReq, ListExternalAccountsRes>;
    /**
     * External Transactions
     *
     * @generated from protobuf rpc: GetExternalAccountBalance
     */
    getExternalAccountBalance(input: GetExternalAccountBalanceReq, options?: RpcOptions): UnaryCall<GetExternalAccountBalanceReq, GetExternalAccountBalanceRes>;
    /**
     * @generated from protobuf rpc: CreateExternalTransaction
     */
    createExternalTransaction(input: CreateExternalTransactionReq, options?: RpcOptions): UnaryCall<CreateExternalTransactionReq, CreateExternalTransactionRes>;
    /**
     * @generated from protobuf rpc: UpdateExternalTransaction
     */
    updateExternalTransaction(input: UpdateExternalTransactionReq, options?: RpcOptions): UnaryCall<UpdateExternalTransactionReq, UpdateExternalTransactionRes>;
    /**
     * @generated from protobuf rpc: VoidExternalTransaction
     */
    voidExternalTransaction(input: VoidExternalTransactionReq, options?: RpcOptions): UnaryCall<VoidExternalTransactionReq, VoidExternalTransactionRes>;
    /**
     * @generated from protobuf rpc: GetExternalTransaction
     */
    getExternalTransaction(input: GetExternalTransactionReq, options?: RpcOptions): UnaryCall<GetExternalTransactionReq, GetExternalTransactionRes>;
    /**
     * Payout reconciliation
     *
     * @generated from protobuf rpc: GeneratePayoutReconciliation
     */
    generatePayoutReconciliation(input: GeneratePayoutReconciliationReq, options?: RpcOptions): UnaryCall<GeneratePayoutReconciliationReq, GeneratePayoutReconciliationRes>;
    /**
     * General Ledger
     *
     * @generated from protobuf rpc: GenerateGeneralLedger
     */
    generateGeneralLedger(input: GenerateGeneralLedgerReq, options?: RpcOptions): UnaryCall<GenerateGeneralLedgerReq, GenerateGeneralLedgerRes>;
    /**
     * @generated from protobuf rpc: GenerateGeneralLedgerPDF
     */
    generateGeneralLedgerPDF(input: GenerateGeneralLedgerPDFReq, options?: RpcOptions): UnaryCall<GenerateGeneralLedgerPDFReq, GenerateGeneralLedgerPDFRes>;
    /**
     * @generated from protobuf rpc: GenerateGeneralLedgerCSV
     */
    generateGeneralLedgerCSV(input: GenerateGeneralLedgerCSVReq, options?: RpcOptions): UnaryCall<GenerateGeneralLedgerCSVReq, GenerateGeneralLedgerCSVRes>;
    /**
     * Journal Entry
     *
     * @generated from protobuf rpc: GetJournalEntry
     */
    getJournalEntry(input: GetJournalEntryReq, options?: RpcOptions): UnaryCall<GetJournalEntryReq, GetJournalEntryRes>;
    /**
     * @generated from protobuf rpc: GenerateJournalEntriesV2
     */
    generateJournalEntriesV2(input: GenerateJournalEntriesV2Req, options?: RpcOptions): UnaryCall<GenerateJournalEntriesV2Req, GenerateJournalEntriesV2Res>;
    /**
     * @generated from protobuf rpc: GenerateJournalEntryForOrderShipment
     */
    generateJournalEntryForOrderShipment(input: GenerateJournalEntryForOrderShipmentReq, options?: RpcOptions): UnaryCall<GenerateJournalEntryForOrderShipmentReq, GenerateJournalEntryForOrderShipmentRes>;
    /**
     * @generated from protobuf rpc: ExportJournalEntryToQuickbooksOnline
     */
    exportJournalEntryToQuickbooksOnline(input: ExportJournalEntryToQuickbooksOnlineReq, options?: RpcOptions): UnaryCall<ExportJournalEntryToQuickbooksOnlineReq, ExportJournalEntryToQuickbooksOnlineRes>;
    /**
     * @generated from protobuf rpc: GetJournalEntryQuickbooksDesktopIIF
     */
    getJournalEntryQuickbooksDesktopIIF(input: GetJournalEntryQuickbooksDesktopIIFReq, options?: RpcOptions): UnaryCall<GetJournalEntryQuickbooksDesktopIIFReq, GetJournalEntryQuickbooksDesktopIIFRes>;
    /**
     * @generated from protobuf rpc: GetJournalEntrySage100CSV
     */
    getJournalEntrySage100CSV(input: GetJournalEntrySage100CSVReq, options?: RpcOptions): UnaryCall<GetJournalEntrySage100CSVReq, GetJournalEntrySage100CSVRes>;
    /**
     * @generated from protobuf rpc: ArchiveJournalEntry
     */
    archiveJournalEntry(input: ArchiveJournalEntryReq, options?: RpcOptions): UnaryCall<ArchiveJournalEntryReq, ArchiveJournalEntryRes>;
    /**
     * @generated from protobuf rpc: DownloadJournalEntryCSV
     */
    downloadJournalEntryCSV(input: DownloadJournalEntryCSVReq, options?: RpcOptions): UnaryCall<DownloadJournalEntryCSVReq, DownloadJournalEntryCSVRes>;
}
/**
 * @generated from protobuf service rd.api.accounting.AccountingService
 */
export class AccountingServiceClient implements IAccountingServiceClient, ServiceInfo {
    typeName = AccountingService.typeName;
    methods = AccountingService.methods;
    options = AccountingService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Account
     *
     * @generated from protobuf rpc: CreateAccount
     */
    createAccount(input: CreateAccountReq, options?: RpcOptions): UnaryCall<CreateAccountReq, CreateAccountRes> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAccountReq, CreateAccountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAccount
     */
    getAccount(input: GetAccountReq, options?: RpcOptions): UnaryCall<GetAccountReq, GetAccountRes> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccountReq, GetAccountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAccounts
     */
    listAccounts(input: ListAccountsReq, options?: RpcOptions): UnaryCall<ListAccountsReq, ListAccountsRes> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAccountsReq, ListAccountsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateAccount
     */
    updateAccount(input: UpdateAccountReq, options?: RpcOptions): UnaryCall<UpdateAccountReq, UpdateAccountRes> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateAccountReq, UpdateAccountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeactivateAccount
     */
    deactivateAccount(input: DeactivateAccountReq, options?: RpcOptions): UnaryCall<DeactivateAccountReq, DeactivateAccountRes> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeactivateAccountReq, DeactivateAccountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReactivateAccount
     */
    reactivateAccount(input: ReactivateAccountReq, options?: RpcOptions): UnaryCall<ReactivateAccountReq, ReactivateAccountRes> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReactivateAccountReq, ReactivateAccountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkUpsertAccounts
     */
    bulkUpsertAccounts(input: BulkUpsertAccountsReq, options?: RpcOptions): UnaryCall<BulkUpsertAccountsReq, BulkUpsertAccountsRes> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkUpsertAccountsReq, BulkUpsertAccountsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Mapping
     *
     * @generated from protobuf rpc: ListMappings
     */
    listMappings(input: ListMappingsReq, options?: RpcOptions): UnaryCall<ListMappingsReq, ListMappingsRes> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListMappingsReq, ListMappingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateMappingAccount
     */
    updateMappingAccount(input: UpdateMappingAccountReq, options?: RpcOptions): UnaryCall<UpdateMappingAccountReq, UpdateMappingAccountRes> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateMappingAccountReq, UpdateMappingAccountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkUpsertMappings
     */
    bulkUpsertMappings(input: BulkUpsertMappingsReq, options?: RpcOptions): UnaryCall<BulkUpsertMappingsReq, BulkUpsertMappingsRes> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkUpsertMappingsReq, BulkUpsertMappingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Balance Sheet
     *
     * @generated from protobuf rpc: GenerateBalanceSheet
     */
    generateBalanceSheet(input: GenerateBalanceSheetReq, options?: RpcOptions): UnaryCall<GenerateBalanceSheetReq, GenerateBalanceSheetRes> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateBalanceSheetReq, GenerateBalanceSheetRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Income Statement
     *
     * @generated from protobuf rpc: GenerateIncomeStatement
     */
    generateIncomeStatement(input: GenerateIncomeStatementReq, options?: RpcOptions): UnaryCall<GenerateIncomeStatementReq, GenerateIncomeStatementRes> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateIncomeStatementReq, GenerateIncomeStatementRes>("unary", this._transport, method, opt, input);
    }
    /**
     * JournalEntries
     *
     * @generated from protobuf rpc: GenerateJournalEntries
     */
    generateJournalEntries(input: GenerateJournalEntriesReq, options?: RpcOptions): UnaryCall<GenerateJournalEntriesReq, GenerateJournalEntriesRes> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateJournalEntriesReq, GenerateJournalEntriesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GenerateJournalEntriesPDF
     */
    generateJournalEntriesPDF(input: GenerateJournalEntriesPDFReq, options?: RpcOptions): UnaryCall<GenerateJournalEntriesPDFReq, GenerateJournalEntriesPDFRes> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateJournalEntriesPDFReq, GenerateJournalEntriesPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GenerateJournalEntriesIIF
     */
    generateJournalEntriesIIF(input: GenerateJournalEntriesIIFReq, options?: RpcOptions): UnaryCall<GenerateJournalEntriesIIFReq, GenerateJournalEntriesIIFRes> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateJournalEntriesIIFReq, GenerateJournalEntriesIIFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * External Accounts
     *
     * @generated from protobuf rpc: CreateExternalAccount
     */
    createExternalAccount(input: CreateExternalAccountReq, options?: RpcOptions): UnaryCall<CreateExternalAccountReq, CreateExternalAccountRes> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateExternalAccountReq, CreateExternalAccountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateExternalAccount
     */
    updateExternalAccount(input: UpdateExternalAccountReq, options?: RpcOptions): UnaryCall<UpdateExternalAccountReq, UpdateExternalAccountRes> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateExternalAccountReq, UpdateExternalAccountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeactivateExternalAccount
     */
    deactivateExternalAccount(input: DeactivateExternalAccountReq, options?: RpcOptions): UnaryCall<DeactivateExternalAccountReq, DeactivateExternalAccountRes> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeactivateExternalAccountReq, DeactivateExternalAccountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListExternalAccounts
     */
    listExternalAccounts(input: ListExternalAccountsReq, options?: RpcOptions): UnaryCall<ListExternalAccountsReq, ListExternalAccountsRes> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListExternalAccountsReq, ListExternalAccountsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * External Transactions
     *
     * @generated from protobuf rpc: GetExternalAccountBalance
     */
    getExternalAccountBalance(input: GetExternalAccountBalanceReq, options?: RpcOptions): UnaryCall<GetExternalAccountBalanceReq, GetExternalAccountBalanceRes> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExternalAccountBalanceReq, GetExternalAccountBalanceRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateExternalTransaction
     */
    createExternalTransaction(input: CreateExternalTransactionReq, options?: RpcOptions): UnaryCall<CreateExternalTransactionReq, CreateExternalTransactionRes> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateExternalTransactionReq, CreateExternalTransactionRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateExternalTransaction
     */
    updateExternalTransaction(input: UpdateExternalTransactionReq, options?: RpcOptions): UnaryCall<UpdateExternalTransactionReq, UpdateExternalTransactionRes> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateExternalTransactionReq, UpdateExternalTransactionRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: VoidExternalTransaction
     */
    voidExternalTransaction(input: VoidExternalTransactionReq, options?: RpcOptions): UnaryCall<VoidExternalTransactionReq, VoidExternalTransactionRes> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<VoidExternalTransactionReq, VoidExternalTransactionRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetExternalTransaction
     */
    getExternalTransaction(input: GetExternalTransactionReq, options?: RpcOptions): UnaryCall<GetExternalTransactionReq, GetExternalTransactionRes> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExternalTransactionReq, GetExternalTransactionRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Payout reconciliation
     *
     * @generated from protobuf rpc: GeneratePayoutReconciliation
     */
    generatePayoutReconciliation(input: GeneratePayoutReconciliationReq, options?: RpcOptions): UnaryCall<GeneratePayoutReconciliationReq, GeneratePayoutReconciliationRes> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<GeneratePayoutReconciliationReq, GeneratePayoutReconciliationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * General Ledger
     *
     * @generated from protobuf rpc: GenerateGeneralLedger
     */
    generateGeneralLedger(input: GenerateGeneralLedgerReq, options?: RpcOptions): UnaryCall<GenerateGeneralLedgerReq, GenerateGeneralLedgerRes> {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateGeneralLedgerReq, GenerateGeneralLedgerRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GenerateGeneralLedgerPDF
     */
    generateGeneralLedgerPDF(input: GenerateGeneralLedgerPDFReq, options?: RpcOptions): UnaryCall<GenerateGeneralLedgerPDFReq, GenerateGeneralLedgerPDFRes> {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateGeneralLedgerPDFReq, GenerateGeneralLedgerPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GenerateGeneralLedgerCSV
     */
    generateGeneralLedgerCSV(input: GenerateGeneralLedgerCSVReq, options?: RpcOptions): UnaryCall<GenerateGeneralLedgerCSVReq, GenerateGeneralLedgerCSVRes> {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateGeneralLedgerCSVReq, GenerateGeneralLedgerCSVRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Journal Entry
     *
     * @generated from protobuf rpc: GetJournalEntry
     */
    getJournalEntry(input: GetJournalEntryReq, options?: RpcOptions): UnaryCall<GetJournalEntryReq, GetJournalEntryRes> {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetJournalEntryReq, GetJournalEntryRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GenerateJournalEntriesV2
     */
    generateJournalEntriesV2(input: GenerateJournalEntriesV2Req, options?: RpcOptions): UnaryCall<GenerateJournalEntriesV2Req, GenerateJournalEntriesV2Res> {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateJournalEntriesV2Req, GenerateJournalEntriesV2Res>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GenerateJournalEntryForOrderShipment
     */
    generateJournalEntryForOrderShipment(input: GenerateJournalEntryForOrderShipmentReq, options?: RpcOptions): UnaryCall<GenerateJournalEntryForOrderShipmentReq, GenerateJournalEntryForOrderShipmentRes> {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateJournalEntryForOrderShipmentReq, GenerateJournalEntryForOrderShipmentRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ExportJournalEntryToQuickbooksOnline
     */
    exportJournalEntryToQuickbooksOnline(input: ExportJournalEntryToQuickbooksOnlineReq, options?: RpcOptions): UnaryCall<ExportJournalEntryToQuickbooksOnlineReq, ExportJournalEntryToQuickbooksOnlineRes> {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept<ExportJournalEntryToQuickbooksOnlineReq, ExportJournalEntryToQuickbooksOnlineRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetJournalEntryQuickbooksDesktopIIF
     */
    getJournalEntryQuickbooksDesktopIIF(input: GetJournalEntryQuickbooksDesktopIIFReq, options?: RpcOptions): UnaryCall<GetJournalEntryQuickbooksDesktopIIFReq, GetJournalEntryQuickbooksDesktopIIFRes> {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetJournalEntryQuickbooksDesktopIIFReq, GetJournalEntryQuickbooksDesktopIIFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetJournalEntrySage100CSV
     */
    getJournalEntrySage100CSV(input: GetJournalEntrySage100CSVReq, options?: RpcOptions): UnaryCall<GetJournalEntrySage100CSVReq, GetJournalEntrySage100CSVRes> {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetJournalEntrySage100CSVReq, GetJournalEntrySage100CSVRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ArchiveJournalEntry
     */
    archiveJournalEntry(input: ArchiveJournalEntryReq, options?: RpcOptions): UnaryCall<ArchiveJournalEntryReq, ArchiveJournalEntryRes> {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept<ArchiveJournalEntryReq, ArchiveJournalEntryRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DownloadJournalEntryCSV
     */
    downloadJournalEntryCSV(input: DownloadJournalEntryCSVReq, options?: RpcOptions): UnaryCall<DownloadJournalEntryCSVReq, DownloadJournalEntryCSVRes> {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept<DownloadJournalEntryCSVReq, DownloadJournalEntryCSVRes>("unary", this._transport, method, opt, input);
    }
}
